import { useState, useCallback, useEffect } from 'react';

const STORAGE_KEY = 'myabode_recently_viewed';
const MAX_ITEMS = 10;

interface RecentlyViewedEntry {
  id: string;
  viewedAt: number; // timestamp
}

const readFromStorage = (): RecentlyViewedEntry[] => {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    return JSON.parse(raw) as RecentlyViewedEntry[];
  } catch {
    return [];
  }
};

const writeToStorage = (entries: RecentlyViewedEntry[]) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
  } catch {
    // storage unavailable
  }
};

export const useRecentlyViewed = () => {
  const [entries, setEntries] = useState<RecentlyViewedEntry[]>(readFromStorage);

  useEffect(() => {
    writeToStorage(entries);
  }, [entries]);

  const trackView = useCallback((id: string) => {
    setEntries(prev => {
      const filtered = prev.filter(e => e.id !== id);
      const updated = [{ id, viewedAt: Date.now() }, ...filtered].slice(0, MAX_ITEMS);
      return updated;
    });
  }, []);

  const clearHistory = useCallback(() => {
    setEntries([]);
  }, []);

  const recentIds = entries.map(e => e.id);

  return { recentIds, entries, trackView, clearHistory };
};
